import React from 'react';

const DeliveryUpdate = () => {
    return (
        <div>
            
        </div>
    );
};

export default DeliveryUpdate;